import { render } from "./CareerFairOutcomes.vue?vue&type=template&id=946fd972&scoped=true"
import script from "./CareerFairOutcomes.vue?vue&type=script&lang=js"
export * from "./CareerFairOutcomes.vue?vue&type=script&lang=js"

import "./CareerFairOutcomes.vue?vue&type=style&index=0&id=946fd972&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-946fd972"

export default script